/**
 * LocationReloadButton
 */
import React from 'react';

// Styles
import './styles.scss';

type Props = *;

export default class LocationReloadButton extends React.PureComponent<Props> {
    handleClick = () => {
        window.location.reload();
    };

    render() {
        return (
            <button
                size="small"
                className="event-quick-update-reload-button"
                onClick={this.handleClick}
                type="button"
            >
                RELOAD
            </button>
        );
    }
}
